var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'add-widget-card': true },on:{"click":_vm.handleClick}},[_c('icon',{attrs:{"icon":['fal', 'layer-plus']}}),_vm._v("   Add widget\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }